$(document).ready(function () {
    $(document).delegate('*[data-toggle="iframe"]', 'click', function (event) {
        event.preventDefault();
        eModal.iframe($(this).attr('href'), $(this).data('title') || ' ');
        eModal.iframe({
            message: $(this).attr('href'),
            title: $(this).data('title') || ' ',
            loading: true
        });
    });
});